import * as React from "react";
import { MoneyDisplayHelper } from "../../../../../../../../react-core/Helpers/MoneyDisplayHelper";
import { FormComponent } from "../../../../../../../../react-core/Html/FormComponent";
import { JsonDateParser } from "../../../../../../../../react-core/Utils/JsonDateParser";
import { CurrencyCode } from "../../../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { CorporateActionModel } from "../../../../../../../../Wrap/Models/Domains/Transactions/CorporateAction/CorporateActionModel";
import { CorporateActionsCollection } from "../../../../../../../../Wrap/Models/Domains/Transactions/CorporateAction/CorporateActionsCollection";
import { Alert } from "../../../../../../../Shared/Components/Alert";
import { AlertType } from "../../../../../../../Shared/Entities/Constants/AlertConstants";
import { sortDirection, Table } from "../../../../../../../Shared/Table/Table";
import { Contents, SortNameEnum } from "../Resource/Contents";
import { CorporateActionsPopupView } from "./CorporateActionsPopupView";

interface ICorporateActionsProps {
    data: CorporateActionsCollection;
    selectedSubAccount: string;
    corpActionType?: string;
    onTableChange: (sortName, sortDirection, minRow, maxRow) => void;
}

interface ICorporateActionsState {
    sortName: SortNameEnum;
    sortDirection: sortDirection;
    currentPage: number;
    isPopUp: boolean;
    selectedCorporateModel: CorporateActionModel;
    isExDateASC: boolean;
    isPostDateASC: boolean;
}

export class CorporateActions extends FormComponent<ICorporateActionsProps, ICorporateActionsState> {
    constructor(props: ICorporateActionsProps) {
        super(props);

        this.state = {
            sortName: SortNameEnum.ExDate,
            sortDirection: sortDirection.DESC,
            currentPage: 1,
            isPopUp: false,
            selectedCorporateModel: null,
            isExDateASC: false,
            isPostDateASC: false,
        };
    }

    private getData() {
        const { corpActionType } = this.props;
        const { sortName, sortDirection, currentPage } = this.state;
        const minRow = (currentPage - 1) * 10 + 1;
        const maxRow = currentPage * 10;
        this.props.onTableChange(sortName, sortDirection, minRow, maxRow);
    }

    private renderElement(): JSX.Element {
        const { currentPage } = this.state;
        const { corpActionType, data } = this.props;
        return (
            <div className="pt-24">
                <div className="mb-50">
                    <Table
                        data={data.Items}
                        col={corpActionType ? this.getCorporateTableColumn() : this.getOtherCorporateTableColumn()}
                        needPagination={{
                            totalNumOfResult: data.TotalRows,
                            currentPage: currentPage,
                            onPaginationChange: (pageIndex, pageSize) => {
                                this.setState(
                                    {
                                        currentPage: pageIndex,
                                    },
                                    () => {
                                        this.getData();
                                    }
                                );
                            },
                        }}
                    />
                </div>
                {this.renderDetailPopUp()}
            </div>
        );
    }

    private getCorporateTableColumn() {
        const { isExDateASC, isPostDateASC } = this.state;
        return [
            {
                title: "Dividend date",
                key: "ExDate",
                thCssWrapper: "ctable-sort",
                render: (data, row, index) => {
                    return JsonDateParser.getFormatDate(data, "dd/MM/yyyy");
                },
                sorter: () => {
                    this.setState(
                        {
                            sortName: SortNameEnum.ExDate,
                            sortDirection: isExDateASC ? sortDirection.DESC : sortDirection.ASC,
                            isExDateASC: !isExDateASC,
                        },
                        () => {
                            this.getData();
                        }
                    );
                },
                sortDirection: isExDateASC ? sortDirection.ASC : sortDirection.DESC,
            },
            {
                title: "Payment date",
                key: "DividendPayDate",
                thCssWrapper: "ctable-sort",
                render: (data, row, index) => {
                    return JsonDateParser.getFormatDate(data, "dd/MM/yyyy");
                },
                sorter: () => {
                    this.setState(
                        {
                            sortName: SortNameEnum.DividendPayDate,
                            sortDirection: isPostDateASC ? sortDirection.DESC : sortDirection.ASC,
                            isPostDateASC: !isPostDateASC,
                        },
                        () => {
                            this.getData();
                        }
                    );
                },
                sortDirection: isPostDateASC ? sortDirection.ASC : sortDirection.DESC,
            },
            {
                title: "Instrument code",
                key: "InstrumentCode",
            },
            {
                title: "Investments",
                key: "Description",
                render: null,
            },
            {
                title: "Amount",
                key: "DivPayable",
                thCssWrapper: "cell-right",
                tdCssWrapper: "cell-right",
                render: (data, row, index) => {
                    return this.getMoneyFormat(data);
                },
            },
            {
                title: "Dividend detail",
                key: "Id",
                thCssWrapper: "cell-right",
                tdCssWrapper: "cell-right",

                render: (data, row, index) => {
                    return <a className="link-btn">{data}</a>;
                },
                onClick: (data, row: CorporateActionModel, index) => {
                    this.setState({ selectedCorporateModel: row, isPopUp: true });
                },
            },
        ];
    }

    private getOtherCorporateTableColumn() {
        const { isExDateASC, isPostDateASC } = this.state;
        return [
            {
                title: "ID",
                key: "Id",
                render: (data, row, index) => {
                    return <a className="link-btn">{data}</a>;
                },
                onClick: (data, row: CorporateActionModel, index) => {
                    this.setState({ selectedCorporateModel: row, isPopUp: true });
                },
            },
            {
                title: "Ex Date",
                key: "ExDate",
                thCssWrapper: "ctable-sort",
                render: (data, row, index) => {
                    return JsonDateParser.getFormatDate(data, "dd/MM/yyyy");
                },
                sorter: () => {
                    this.setState(
                        {
                            sortName: SortNameEnum.ExDate,
                            sortDirection: isExDateASC ? sortDirection.DESC : sortDirection.ASC,
                            isExDateASC: !isExDateASC,
                        },
                        () => {
                            this.getData();
                        }
                    );
                },
                sortDirection: isExDateASC ? sortDirection.ASC : sortDirection.DESC,
            },
            {
                title: "Instrument code",
                key: "InstrumentCode",
            },
            {
                title: "Investments",
                key: "Description",
                render: null,
            },
            {
                title: "Type",
                key: "Type",
            },
            {
                title: "Action Required Before",
                key: "Type",
                render: (data, row: CorporateActionModel, index) => {
                    const defaultDate = JsonDateParser.getFormatDate(row.ActionRequiredBy, "yyyy-MM-dd");
                    if (defaultDate == "1-01-01") {
                        return "No Action Required";
                    } else if (
                        (row.Status && row.Status.toLowerCase() === "Posted") ||
                        (row.ActionRequiredBy &&
                            row.DealToDate &&
                            JsonDateParser.toDate(row.ActionRequiredBy) < new Date() &&
                            JsonDateParser.toDate(row.DealToDate) < new Date() &&
                            row.Type.toLowerCase() === "renounceable rights issue") ||
                        (row.ActionRequiredBy &&
                            JsonDateParser.toDate(row.ActionRequiredBy) < new Date() &&
                            row.Type.toLowerCase() === "non-renounceable rights issue")
                    ) {
                        return "Closed";
                    } else {
                        return JsonDateParser.getFormatDate(row.ActionRequiredBy, "dd/MM/yyyy");
                    }
                },
            },
        ];
    }

    private getMoneyFormat(val: number): string {
        let formatMoney = MoneyDisplayHelper.FromatMoneyDisplay(Math.abs(val), CurrencyCode.GBP);
        if (val < 0) {
            formatMoney = "-" + formatMoney;
        }
        return formatMoney;
    }

    private renderDetailPopUp(): JSX.Element {
        const { isPopUp, selectedCorporateModel } = this.state;
        if (isPopUp) {
            return (
                <CorporateActionsPopupView
                    showBox={isPopUp}
                    corpActionType={this.props.corpActionType}
                    data={selectedCorporateModel}
                    onChange={() => {
                        this.setState({ isPopUp: false });
                    }}
                    selectedSubAccount={this.props.selectedSubAccount}
                />
            );
        }
        return null;
    }

    render() {
        const { data, corpActionType } = this.props;
        if (!data) {
            return null;
        } else if (data && data.Items.length < 1) {
            return (
                <Alert
                    alertType={AlertType.Warning}
                    message={corpActionType ? Contents.NoDividendSummaryDataErrorMessage : Contents.NoDataErrorMessage}
                />
            );
        } else {
            return this.renderElement();
        }
    }
}
